import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Testing",
    subheader:
      "Seamlessly alternate between live and test mode without creating a second link."
  }),
  rows: [
    {
      title: {
        value: "Test mode",
        tooltip: `Simply add /test/ to any payment link url to enter test mode.`
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
